/**
 * Helper: Video
 * -----------------------------------------------------------------------------
 * Video element helper utility functions.
 *
 */

/**
 * Sets base states for all video player elements.
 * @returns {Object}
 */
export function VideoPlayers() {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    videoPlayer: document.querySelectorAll('video'),
  }

  /**
   * Initialize component.
   */
  function init() {
    setAttributeDefaults()
  }

  /**
   * Sets the video players' attribute defaults.
   */
  function setAttributeDefaults() {
    if (hasReducedMotion()) {
      [...nodeSelectors.videoPlayer].forEach((element) => {
        element.removeAttribute('autoplay')
      })
    }
  }

  /**
   * Returns if the user has reduced motion enabled.
   * @returns {Boolean}
   */
  function hasReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
